export function normalizeProfileImageUrlForHttps(profileImageUrl) {
    if (typeof profileImageUrl !== "string") {
        return profileImageUrl;
    }
    return profileImageUrl.replace(/^http:\/\/res\.cloudinary\.com\/trebble-fm\//i, "https://res.cloudinary.com/trebble-fm/");
}
